import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

export default function HomeSection3() {
  const partners = [
    { name: "Generali", logo: "assets/images/generali.png" },
    { name: "TripMate", logo: "assets/images/tripMateLogo2.png" },
    { name: "Healthee", logo: "assets/images/healthee.png" },
    { name: "Legado", logo: "assets/images/Legado.svg" },
    { name: "Healthy Habits", logo: "assets/images/healthyHabits.png" },
    { name: "CrunchBase", logo: "assets/images/crunchBase.png" },
  ];

  const CustomPrevArrow = (props) => {
    const { onClick } = props;
    return (
      <div
        className="swiper-button-prev"
        onClick={onClick}
        role="button"
        aria-label="Previous partner"
        tabIndex={0}
      ></div>
    );
  };

  const CustomNextArrow = (props) => {
    const { onClick } = props;
    return (
      <div
        className="swiper-button-next"
        onClick={onClick}
        role="button"
        aria-label="Next partner"
        tabIndex={0}
      ></div>
    );
  };

  const settings = {
    dots: false,
    infinite: true,
    speed: 600,
    slidesToShow: 5,
    slidesToScroll: 1,
    initialSlide: 0,
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: true,
    cssEase: "cubic-bezier(0.4, 0, 0.2, 1)",
    prevArrow: <CustomPrevArrow />,
    nextArrow: <CustomNextArrow />,
    responsive: [
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1150,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 565,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
        },
      },
    ],
  };

  return (
    <section className="organization-section" aria-label="Trusted partners">
      <div className="organization-section-block">
        <h2 className="organization-title">You're In Good Company</h2>
        <p className="organization-dec">
          Trusted by leading organizations worldwide to provide FootprintID® and peace of mind.
        </p>
        <div className="organization-img-section">
          <Slider {...settings}>
            {partners.map((partner, index) => (
              <div key={index} className="image-section">
                <img 
                  alt={`${partner.name} - Trusted Partner`} 
                  className="img-fluid" 
                  src={partner.logo}
                  loading="lazy"
                />
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </section>
  );
}
